import { render, staticRenderFns } from "./NewTag.vue?vue&type=template&id=ae9058aa&scoped=true"
import script from "./NewTag.vue?vue&type=script&lang=js"
export * from "./NewTag.vue?vue&type=script&lang=js"
import style0 from "./NewTag.vue?vue&type=style&index=0&id=ae9058aa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9058aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae9058aa')) {
      api.createRecord('ae9058aa', component.options)
    } else {
      api.reload('ae9058aa', component.options)
    }
    module.hot.accept("./NewTag.vue?vue&type=template&id=ae9058aa&scoped=true", function () {
      api.rerender('ae9058aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskExamine/task/components/Tag/NewTag.vue"
export default component.exports